<template>
    <div>
        <el-form ref="form"
                 label-width="110px">
            <el-form-item label="用户名/昵称:"> <el-input type="text"
                          v-model="form.userName" /> </el-form-item>
            <el-form-item label="手机:"> <el-input type="text"
                          v-model="form.mobile" /> </el-form-item>
            <el-form-item label="真实姓名:">
                <div style="display:flex">
                    <el-input type="text"
                              v-model="form.realName"
                              style="width:200px;marginRight:20px" />
                    <span class="msg">一旦实名认证将不能修改，并且要和提现银行卡/微信/支付宝的姓名一致</span>
                </div>
            </el-form-item>
            <el-form-item label="身份证号:">
                <div style="display:flex">
                    <el-input type="text"
                              v-model="form.idNumber"
                              style="width:200px;marginRight:20px" />
                    <span class="msg">一旦实名认证将不能修改，并且要和提现银行卡/微信/支付宝的姓名一致</span>
                </div>
            </el-form-item>
            <el-form-item label="入住彩种:">
                <el-select v-model="form.lotteryType"
                           placeholder="请选择">
                    <el-option v-for="item in select.arr"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="身份证上传:">
                <div class="idCardUpload">
                    <div class="zm"
                         @click="fileType = 'cardZm'">
                        <el-upload action=''
                                   :auto-upload="false"
                                   :show-file-list="false"
                                   :onChange="chooseFile">
                            <el-image v-if="form.cardZm"
                                      :src='form.cardZm'></el-image>
                            <span v-else>请上传身份证正面</span>
                        </el-upload>
                    </div>
                    <div class="fm"
                         @click="fileType = 'cardFm'">
                        <el-upload action=''
                                   :auto-upload="false"
                                   :show-file-list="false"
                                   :onChange="chooseFile">
                            <el-image v-if="form.cardFm"
                                      :src='form.cardFm'></el-image>
                            <span v-else>请上传身份证反面</span>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="头像上传:">
                <div class="idCardUpload">
                    <div @click="fileType = 'avatar'">
                        <el-upload action=''
                                   :auto-upload="false"
                                   :show-file-list="false"
                                   :onChange="chooseFile">
                            <el-image v-if="form.avatar"
                                      :src='form.avatar'></el-image>
                            <span v-else>请上传头像</span>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="是否有60人以上彩票QQ群,微信群"
                          label-width="240px">
                <el-input v-model="form.is60RenQqWx"
                          type="text"
                          placeholder="如果没有填无，如果有，说明QQ群号，微信号" />
            </el-form-item>
            <el-form-item label="是否有投注站">
                <el-input v-model="form.isTzz"
                          type="text"
                          placeholder="如果没有填无，如果有说明投注站信息" />
            </el-form-item>
            <el-form-item label="是否每年都有原创思路定制成软件"
                          style="paddingBottom:0"
                          label-width="230px">
                <el-radio-group v-model="form.dinzhiruanjian">
                    <el-radio label="否">否</el-radio>
                    <el-radio label="是">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否不定期根据自己的需要添置好用软件"
                          style="paddingBottom:0"
                          label-width="270px">
                <el-radio-group v-model="form.haoyongruanjian">
                    <el-radio label="否">否</el-radio>
                    <el-radio label="是">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="qq号">
                <el-input type="text"
                          v-model="form.qqNum" />
            </el-form-item>
            <el-form-item label="微信号">
                <el-input type="text"
                          v-model="form.wxNum" />
            </el-form-item>
            <el-form-item label="生日">
                <!-- <el-input type="text" v-model="form.birthday"/> -->
                <el-date-picker v-model="form.birthday"
                                type="date"
                                value-format='yyyy-MM-dd'
                                placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="性别"
                          style="paddingBottom:0">
                <el-radio-group v-model="form.gender">
                    <el-radio label="男">男</el-radio>
                    <el-radio label="女">女</el-radio>
                    <el-radio label="保密">保密</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="分享使用和开发软件的小故事"
                          label-width="200px">
                <el-input type="textarea"
                          v-model="form.sss_msg"
                          placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="软件交易师最喜欢的彩票座右铭"
                          label-width="210px">
                <div style="display:flex">
                    <el-input type="text"
                              placeholder="用一句话概括"
                              v-model="form.sssLikeOral" />
                    <el-button type="primary"
                               style="margin-left: 20px;"
                               @click="$refs.popupMotto.init()">选择座右铭</el-button>
                </div>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary"
                           @click="submit">确定</el-button>
            </el-form-item>
        </el-form>
		<motto ref="popupMotto" @confirm="e=>this.form.sssLikeOral = e"></motto>
    </div>
</template>

<script>import motto from '@/components/motto/index.vue'
export default {
	components:{ motto },
    data () {
        return {
            checkList: ['两年以内'],
            select: {
                arr: [
                    { label: "双色球", value: "双色球", },
                    { label: "大乐透", value: "大乐透", },
                    { label: "福彩3D", value: "福彩3D", },
                    { label: "排列三", value: "排列三", },
                ],
                val: "",
            },
            imageUrl: '',

            fileType: '',

            form: {
                userName: '',        //用户名
                mobile: '',          //手机号
                realName: '',        //真实姓名
                idNumber: '',        //身份证好
                lotteryType: '',     //彩种
                cardZm: '',          //身份证反面
                cardFm: '',          //身份证正面
                avatar: '',          //头像
                is60RenQqWx: '',     //是否又60人以上的qq群微信群
                isTzz: '',           //是否是投注站
                dinzhiruanjian: '否',  //定制软件
                haoyongruanjian: '否', //好用软件
                qqNum: '',           //qq号
                wxNum: '',           //微信号
                birthday: '',        //生日
                gender: '男',          //性别
                sss_msg: '',         //缩水师认识
                sssLikeOral: '',     //座右铭
            }
        };
    },
    methods: {
        chooseFile (e) {
            const formData = new FormData();
            formData.append("file", e.raw);
            this.$http.post('/uploadUtil', formData).then(res => this.form[this.fileType] = res.message)
        },
        submit () {
            console.log(this.form);
            for (let i in this.form) {
                if (!this.form[i]) {
                    this.$message.error('存在未输入的内容')
                    return
                }
            }
            console.log('全部填写完成了');
            this.$http.post('/user/apply', {
                userId: JSON.parse(localStorage.getItem('userInfo')).userId,
                type: '4',
                json: JSON.stringify(this.form)
            }).then(res => {
                console.log(res);
                this.$message.success(res.message)
                for (let i in this.form) {
                    this.form[i] = ''
                }
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.el-image {
    height: 150px;
}
.idCardUpload {
    display: flex;
    font-size: 30px;
    color: rgba(0, 0, 0, 0.2);
    > div {
        border: 1px solid rgba(0, 0, 0, 0.1);
        height: 150px;
        line-height: 150px;
        width: 300px;
        text-align: center;
        margin-right: 20px;
    }
}
.el-form-item {
    margin-bottom: 11px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 11px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.form {
    border: 1px solid rgba(0, 0, 0, 0.2);
    > div {
        padding: 10px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        .el-input {
            width: 160px;
            margin-right: 10px;
        }
        > span {
            &.require {
                &::before {
                    content: '* ';
                    color: red;
                }
            }
            &:nth-child(1) {
                display: inline-block;
                min-width: 130px;
                text-align: right;
                margin-right: 10px;
            }
        }
        .msg {
            color: #a16222;
            font-size: 15px;
        }
    }
}
</style>